"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFilterValuesEndpointRequest = void 0;
const ProductSearchQuery_1 = require("../../types/ProductSearchQuery");
function createFilterValuesEndpointRequest(parameters) {
    return {
        method: 'GET',
        endpoint: `filters/${parameters.groupName}/values`,
        params: Object.assign(Object.assign(Object.assign({}, (0, ProductSearchQuery_1.queryParamsFromProductSearchQuery)(parameters.where)), (parameters.campaignKey
            ? { campaignKey: parameters.campaignKey }
            : undefined)), (parameters.orFiltersOperator &&
            parameters.orFiltersOperator.length > 1
            ? { orFiltersOperator: parameters.orFiltersOperator.join(',') }
            : undefined)),
    };
}
exports.createFilterValuesEndpointRequest = createFilterValuesEndpointRequest;
